import React from "react";


function SvgAudio(props) {
  let blur = "";
  if (props.activeMove) {
    blur = 40;
  }

  return (
    <svg
    style={{verticalAlign:"middle"}}
      xmlns="http://www.w3.org/2000/svg"
      id="Audio_Icon"
      data-name="Audio Icon"
      width={props.width}
      height={props.height}
      viewBox="0 0 24 24"
    >
      <path id="Shape" d="M0,0H24V24H0Z" fill="none" />
      <path
        id="Combined_Shape"
        data-name="Combined Shape"
        d="M1.857,0H9.736a1.5,1.5,0,0,1,.969.355l4.764,4.029A1.5,1.5,0,0,1,16,5.529V18.083C16,19.874,15.98,20,14.143,20H1.857C.02,20,0,19.874,0,18.083V1.917C0,.126.02,0,1.857,0Z"
        transform="translate(4 2)"
        fill={"#ffa94d"+blur}
      />
      <path
        id="Combined_Shape-2"
        data-name="Combined Shape"
        d="M1.833,9A1.7,1.7,0,0,1,0,7.472,1.7,1.7,0,0,1,1.833,5.944a2.163,2.163,0,0,1,.611.087V1.792a.714.714,0,0,1,.482-.684L6.441.033a.693.693,0,0,1,.893.684V1.792a.74.74,0,0,1-.611.653q-.6.142-3.056.611V7.5a.837.837,0,0,1-.013.152A1.75,1.75,0,0,1,1.833,9Z"
        transform="translate(8 8)"
        fill="#fff"
      />
    </svg>
  );
}
export default React.memo(SvgAudio);
